import { defaultMetaImageLink, perPortionPrice } from './config'

export const getPortionPrice = (recipe) => {
  const surcharge = recipe?.surcharge?.pricePerPortion || 0

  return surcharge ? (perPortionPrice + surcharge).toFixed(2) : perPortionPrice
}

export const getMetaImageLink = (recipe) => {
  const crops = recipe?.images?.[0]?.crops
  const image = crops && crops.find((imageProps) => imageProps.width === 700)

  return image ? image.url : defaultMetaImageLink
}

export const getRecipeDetailURL = (recipe) =>
  `https://www.gousto.co.uk/menu?recipeDetailId=${recipe.coreId}`
